<template>
  <div>
    <ui-card
      :is-loading="isLoading"
      class="overview-card h-100"
    >
      <div class="card-header overview-card__header mb-4 pb-2">
        <ui-icon name="overdue-payouts" size="32px" />
        <h4 class="card-title overview-card__title">
          Overdue payouts
        </h4>
      </div>
      <template v-if="previewPayouts.length">
        <div
          v-for="item in previewPayouts"
          :key="item.workplace.id"
          class="d-flex justify-content-between mt-3"
        >
          <router-link
            :to="{ name: 'location-view', params: { locationId: item.workplace.id }}"
            class="card-label overview-card__label"
          >
            {{ item.workplace.name }}
          </router-link>
          <div class="card-value pl-2 ml-auto">
            {{ item.totalAmountTips.amount | money(item.totalAmountTips.currency) }}
          </div>
          <stats-overdue-info
            :days="item.overdueDays"
            :since="item.firstNoneTaxCalculationDate"
            class="ml-2"
          />
        </div>
      </template>
      <span v-else class="text-gray">
        {{ $t('noData') }}
      </span>

      <template #footer>
        <stats-overdue-payouts-modal
          v-if="items.length > previewCount"
          :payouts="items"
        >
          <template #activator="{ open }">
            <ui-button
              link
              type="primary"
              @click="open"
            >
              {{ $t('form.buttons.viewAll') }}
            </ui-button>
          </template>
        </stats-overdue-payouts-modal>
      </template>
    </ui-card>
  </div>
</template>

<script>
import api from '@/api';
import StatsOverduePayoutsModal from '@/components/Stats/StatsOverduePayoutsModal.vue';
import StatsOverdueInfo from '@/components/Stats/StatsOverdueInfo.vue';
import StatsMixin from './StatsMixin';

export default {

  mixins: [
    StatsMixin,
  ],

  components: {
    StatsOverduePayoutsModal,
    StatsOverdueInfo,
  },

  data: () => ({
    items: [],
    previewCount: 5,
  }),

  computed: {
    previewPayouts() {
      return this.items.slice(0, this.previewCount);
    },
  },

  methods: {
    async load() {
      const { data } = await api.locations.getOverduePayouts({
        salesId: this.staffId,
      });

      if (data) {
        this.items = data;
      }
    },
  },
};
</script>
